"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("obsTaelysWatermark", function(obsCopyrightPopin) {
   return {
       restrict     : "E",
       scope        : true,
       replace      : true,
       template     : require("./obsTaelysWatermark.html"),
       link : function($scope, $el, $attrs) {

           $scope.openCopyrightPopin = function() {
               obsCopyrightPopin.open();
           };

       }
   };
});

ngModule.factory("leafletTaelysWatermark", function($rootScope, leaflet, directiveUtils) {

    leaflet.Control.TaelysWatermark = leaflet.Control.extend({

        options: {
            position: 'bottomright'
        },

        onAdd : function(map) {
            var linkFn = directiveUtils.compileDirective("obsTaelysWatermark");
            var watermark = linkFn($rootScope);
            return watermark[0];
        }

    });

    return leaflet.Control.TaelysWatermark;
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/presentation/obsTaelysWatermark.js